import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  FormControlLabel,
  FormGroup,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Switch,
} from '@mui/material';

import type { CalcSettingType } from '../../types/calc/calc';
import { CalcBaseDateSetting } from '../../types/calc-base-date-setting/calc-base-date-setting';

type CalcSettingModalType = {
  dispSettingModal: boolean;
  setDispSettingModal: React.Dispatch<React.SetStateAction<boolean>>;
  calcSetting: CalcSettingType;
  setCalcSetting: React.Dispatch<React.SetStateAction<CalcSettingType>>;
  calcBaseDateData: CalcBaseDateSetting[] | null;
};

export const CalcSettingModal = ({
  dispSettingModal,
  setDispSettingModal,
  calcSetting,
  setCalcSetting,
  calcBaseDateData,
}: CalcSettingModalType) => {
  // useEffect(() => {}, []);

  /** 計算設定を閉じる */
  const closeModal = () => {
    setDispSettingModal(false);
  };

  /** 選択フォーム変化時のイベントハンドラ */
  const inputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, type, value, checked } = event.target;
    setCalcSetting((prev) => ({
      ...prev,
      [name]: (type === 'checkbox' && !checked) || !value ? undefined : value,
    }));
  };

  // const selectChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
  //   const { name, value } = event.target;
  //   setCalcSetting((prev) => ({
  //     ...prev,
  //     [name]: value || undefined,
  //   }));
  // };

  return (
    <Dialog
      open={dispSettingModal}
      disableEscapeKeyDown
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            // const email = formJson.email;
            const email = 'sample@mail.com';
            console.log(email);
            closeModal();
          },
        },
      }}
    >
      <DialogTitle>計算設定</DialogTitle>
      <DialogContent>
        <DialogContentText>
          計算時のオプションを指定してください。
        </DialogContentText>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                name="originalRoute"
                checked={calcSetting.originalRoute}
                onChange={inputChangeHandler}
              />
            }
            label="指定した経路通りに検索"
          />
          <FormControlLabel
            control={
              <Switch
                name="departureStation"
                checked={calcSetting.departureStation}
                onChange={inputChangeHandler}
              />
            }
            label="発駅単駅指定"
          />
          <FormControlLabel
            control={
              <Switch
                name="arrivalStation"
                checked={calcSetting.arrivalStation}
                onChange={inputChangeHandler}
              />
            }
            label="着駅単駅指定"
          />
          <FormControlLabel
            control={
              <Switch
                name="otherLineRoundTrip"
                checked={calcSetting.otherLineRoundTrip}
                onChange={inputChangeHandler}
              />
            }
            label="新下関〜博多間別線往復"
          />

          <FormControl fullWidth sx={{ marginTop: '5px' }} size="small">
            <InputLabel id="demo-simple-select-label">計算基準日</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={calcSetting.calcBaseDateId ?? ''}
              label="計算基準日"
              onChange={(e) =>
                setCalcSetting((prev) => ({
                  ...prev,
                  calcBaseDateId: Number(e.target.value),
                }))
              }
            >
              {(calcBaseDateData ?? []).map((item: any) => {
                return (
                  <MenuItem
                    value={item.calcBaseDateSettingId}
                    key={item.calcBaseDateSettingId}
                    defaultValue={item.isCurrentFare}
                  >
                    {item.calcStartDate}~{item.calcEndDate}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>設定</Button>
      </DialogActions>
    </Dialog>
  );
};
